import { render } from "./VerticalTextDivider.vue?vue&type=template&id=f8fbdcee&scoped=true"
import script from "./VerticalTextDivider.vue?vue&type=script&lang=js"
export * from "./VerticalTextDivider.vue?vue&type=script&lang=js"

import "./VerticalTextDivider.vue?vue&type=style&index=0&id=f8fbdcee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8fbdcee"]])

export default __exports__